import { Component, ViewChild, OnInit } from '@angular/core';
import { SharedataService } from './service/sharedata.service';
import { LcCropperImgEditorComponent } from './lc-editor/lc-cropper-imgeditor.component';
@Component({
  selector: 'lc-cropper-img-view',
  templateUrl: './lc-cropper-img-view.component.html',
  styleUrls: ['./lc-cropper-img-view.component.scss']
})
export class LcCropperImgViewComponent implements OnInit {
  @ViewChild(LcCropperImgEditorComponent) 
  editor: LcCropperImgEditorComponent;
  constructor(
    public sharedata: SharedataService) {
  }
 public load(url:string){
    this.onChangeLoader({
      loaded: true,
      // name: 'yundan',
      // type: 'image/jpeg',
      url,
    });
  }
  ngOnInit(): void {
 
  }
  onChangeLoader(value) {
    const that = this;
    // 图片载入
    that.sharedata.data = value;
    // 下载路径要更新
    this.sharedata.handledata({});
  }
  updateChange(value) {
    const that = this;
    // 下载路径要更新
    this.sharedata.handledata({});
    // 更新editor组件，主动更新视图
    this.sharedata.data.loaded = false;
    setTimeout(() => {
      that.sharedata.data.loaded = true;
    }, 0);
  }

  navbarchange(action) {
    switch (action) {
      case 'crop':
        this.editor.crop();
        break;

      case 'clear':
        this.editor.clear();
        break;

      case 'restore':
        this.editor.restore();
        break;

      case 'remove':
        this.editor.reset();
        break;

      default:
    }
  }

}
